// How an order is named to people (Oct 2026, Chris's review M8): the till's number for it,
// "#047" (`backend/order_numbers.py`), counting up through the trading day. `withTill` adds
// which till, for the back office, where two tills' #047s sit side by side: "Till 2 · #047".
// An order from before numbers keeps the start of its id.

export function orderRef(order, { withTill = false } = {}) {
  if (!order) return '';
  if (order.number) {
    const n = `#${String(order.number).padStart(3, '0')}`;
    return withTill && order.terminal_label ? `${order.terminal_label} · ${n}` : n;
  }
  return order.id ? `#${String(order.id).slice(0, 8)}` : '';
}
